import { ChakraProvider } from "@chakra-ui/react";
import type { ReactElement } from "react";
import { system } from "../../theme";
import { ColorModeProvider, type ColorModeProviderProps } from "./color-mode";

export function Provider(props: ColorModeProviderProps): ReactElement {
    return (
        <ChakraProvider value={system}>
            <ColorModeProvider
                {...props}
                defaultTheme="light"
                forcedTheme="light"
            />
        </ChakraProvider>
    );
}
